import { ForwardedRef, forwardRef } from 'react';

import { inputTypes, InputTypesProps } from './config';

interface IProps {
  variant?: 'time' | 'toggle' | 'default';
}

const Input = forwardRef(
  ({ variant, ...props }: IProps & InputTypesProps, ref: ForwardedRef<HTMLInputElement>) =>
    inputTypes({ ...props, ref })[variant ?? 'default'],
);

Input.displayName = 'Input';

export default Input;
